/**
 * Set up routing for all QuickTask views
 *
 * For an example with protected routes, refer to /product/ProductRouter.js.jsx
 */

// import primary libraries
import React from 'react'
import { Route, Switch } from 'react-router-dom'

// import global components
import Binder from '../../global/components/Binder.jsx'
import { LazyBoundary } from '../../global/components/ChunkErrorBoundary.jsx'
import YTRoute from '../../global/components/routing/YTRoute.jsx'

// `config/resourceRoutes.js` mounts this router eagerly, and the request
// lists are on the shared table, so a static import would put TanStack,
// Radix, lucide and the ui/ components in the entry bundle.
const LazyWorkspaceRequests = React.lazy(
  () => import('../request/views/WorkspaceRequests.jsx'),
)
const WorkspaceRequests = props => (
  <LazyBoundary>
    <LazyWorkspaceRequests {...props} />
  </LazyBoundary>
)

class RequestTaskRouter extends Binder {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <Switch>
        <YTRoute
          breadcrumbs={[
            // eslint-disable-next-line no-undef
            { display: 'Workspaces', path: `/firm/${firmId}/workspaces` },
            { display: 'Request List', path: null },
          ]}
          component={WorkspaceRequests}
          exact
          path="/firm/:firmId/workspaces/:clientId/request-list/:requestId"
          staff={true}
        />
      </Switch>
    )
  }
}

export default RequestTaskRouter
